import { api } from '../api'

export const departmentsApi = api
  .enhanceEndpoints({
    addTagTypes: ['departments'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDepartmentList: builder.query({
        providesTags: ['departments'],
        query: (params) => ({
          url: '/department',
          method: 'GET',
          params,
        }),
        transformResponse: (response) => response?.data || [],
      }),
    }),
  })

export const { useGetDepartmentListQuery } = departmentsApi
